import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=d2727b90&"
import script from "./Doctor.vue?vue&type=script&lang=ts&"
export * from "./Doctor.vue?vue&type=script&lang=ts&"
import style0 from "./Doctor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports